import { AxiosService } from 'src/axios/axios.service';
import type {
  tListTemplateDraftsResponse,
  tSavedTemplateDraftResponse,
  tSubmittedTemplateDraftResponse,
  tTemplateDraftPayload,
} from '../types/TemplateDraft.types';

// Same routing as every other `/whatsapp-api/meta/:ws/templates*` call: the
// legacy gateway proxies the whole `/whatsapp-api/*` prefix to
// whatsapp-business-service, so no BFF change is needed.
const config = { headers: {}, isLegacy: true };

const base = (workspaceId: string) => `/whatsapp-api/meta/${workspaceId}/template-drafts`;

/**
 * Template drafts (INT-1494). Saving never needs a connected account;
 * submitting does, and answers 422 `wba-10114` without one.
 */
export const TemplateDraftsService = Object.freeze({
  list: (workspaceId: string): Promise<tListTemplateDraftsResponse> =>
    AxiosService.get<tListTemplateDraftsResponse>(base(workspaceId), config),

  create: (
    workspaceId: string,
    payload: tTemplateDraftPayload,
  ): Promise<tSavedTemplateDraftResponse> =>
    AxiosService.post<tTemplateDraftPayload, tSavedTemplateDraftResponse>(
      base(workspaceId),
      payload,
      config,
    ),

  update: (
    workspaceId: string,
    uuid: string,
    payload: tTemplateDraftPayload,
  ): Promise<tSavedTemplateDraftResponse> =>
    AxiosService.put<tTemplateDraftPayload, tSavedTemplateDraftResponse>(
      `${base(workspaceId)}/${uuid}`,
      payload,
      config,
    ),

  remove: (workspaceId: string, uuid: string): Promise<void> =>
    AxiosService.delete<void>(`${base(workspaceId)}/${uuid}`, config),

  submit: (
    workspaceId: string,
    uuid: string,
    acknowledgeSimilar = false,
  ): Promise<tSubmittedTemplateDraftResponse> =>
    AxiosService.post<{ acknowledge_similar: boolean }, tSubmittedTemplateDraftResponse>(
      `${base(workspaceId)}/${uuid}/submit`,
      { acknowledge_similar: acknowledgeSimilar },
      config,
    ),
});
